// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"059d6a22","455":"9cf49a80","977":"7be9ace8"}[chunkId] + ".chunk.js";
};